import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-lie",
  "use": "icon-lie-usage",
  "viewBox": "0 0 1137 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1137 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-lie\"><path d=\"M56.888889 0h1024a56.888889 56.888889 0 0 1 0 113.777778H56.888889a56.888889 56.888889 0 1 1 0-113.777778z m0 455.111111h1024a56.888889 56.888889 0 0 1 0 113.777778H56.888889a56.888889 56.888889 0 0 1 0-113.777778z m0 455.111111h1024a56.888889 56.888889 0 0 1 0 113.777778H56.888889a56.888889 56.888889 0 0 1 0-113.777778z\" p-id=\"5136\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol